import {
  Component,
  Inject,
  forwardRef,
  PLATFORM_ID,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { NgAisInstantSearch } from 'angular-instantsearch';
import { CatalogWidgetCheckboxListComponent } from '../checkbox-list/catalog-widget-checkbox-list.component';
import { SizeGuide } from '@app/shared/model/interfaces/sizeGuide/sizeGuide';

@Component({
  selector: 'vc-catalog-widget-short-checkbox-list',
  templateUrl: './catalog-widget-short-checkbox-list.component.html',
  styleUrls: ['./catalog-widget-short-checkbox-list.component.scss']
})
export class CatalogWidgetShortCheckboxListComponent extends CatalogWidgetCheckboxListComponent implements OnChanges {
  @Input()
  sizeLabels: any;

  @Input()
  sizeGuide: SizeGuide;

  @Output() clickOpenSizeGuide = new EventEmitter<string>();

  sizeId: string;
  sizeLabel: string;

  constructor(
    @Inject(forwardRef(() => NgAisInstantSearch)) public instantSearchParent,
    @Inject(PLATFORM_ID) platformId: object
  ) {
    super('CatalogWidgetShortCheckboxListComponent', platformId);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.sizeId) {
      this.sizeId = typeof this.options?.facet === 'string' ? this.options?.facet.split('.')[2].substring(4) : '1';
    }
    if (changes.sizeLabels?.currentValue) {
      this.sizeLabel = changes.sizeLabels?.currentValue[this.sizeId];
    }
  }

  openSizeGuide() {
    this.clickOpenSizeGuide.emit(this.sizeId);
  }
}
